import {AjaxFactory, HttpMethod} from '../../_libs/redux-observable-list';
import {ReduxRequest} from '../../core-utilities/redux-request';
import {isCordovaBuild} from '../../config/constants';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {getSignupUser} from '../reducers/state';
import {baseReduxRequestOptions} from './requests';
import {SIGNUP_USER_PREFIX} from './state';

const reduxRequestOptions = {
  prefix: SIGNUP_USER_PREFIX,
  getState: getSignupUser,
  requestFactory: buildSignupUserAjaxFactory({
    ...BASE_REDUX_LIST_OPTIONS,
  }),
  buildRequest: buildBody,
  ...baseReduxRequestOptions,
};
/** @type {ReduxRequest} */
export const signupUserRequest = new ReduxRequest(reduxRequestOptions);

function buildBody(state, payload) {
  const body = {
    include: ['profile', 'firebaseToken'],
    profile: payload,
  };

  if (isCordovaBuild()) {
    body.scope = 'openid offline_access';
  } else {
    body.scope = 'openid';
  }

  return body;
}

/**
 * Endpoint does not require an auth token for obvious reasons.
 * @param options
 * @return {AjaxFactory}
 */
function buildSignupUserAjaxFactory(options) {
  return new AjaxFactory({
    crossDomain: options.crossDomain,
    method: HttpMethod.POST,
    useBody: true,
    url: `${options.baseApiUrl}/auth/signup`,
    responseType: request => 'json',
  });
}



// WEBPACK FOOTER //
// ./src/js/auth/redux/signupUser.js